import { SectionHeader } from "./SectionHeader";
import useReveal from "@/lib/useReveal";
import { useSection } from "@/lib/SiteContent";
import { imageUrl } from "@/lib/api";

const FALLBACK = {
  intro: "",
  custom_items: [],
};

export const Gaveliste = () => {
  const gav = useSection("gaveliste", FALLBACK);
  const refIntro = useReveal();
  const items = gav.custom_items || [];

  return (
    <section
      id="gaveliste"
      data-testid="gaveliste-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-24 bg-[#F3F5E7]"
    >
      <div className="max-w-5xl mx-auto">
        <SectionHeader eyebrow="Kapittel V" title="Gaveliste" testId="gaveliste" />

        <div ref={refIntro} className="reveal text-center max-w-2xl mx-auto">
          <p className="text-[#5A7682] font-light text-base md:text-lg leading-relaxed">
            {gav.intro}
          </p>
        </div>

        {items.length > 0 && (
          <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
            {items.map((it, idx) => (
              <GiftCard key={idx} item={it} idx={idx} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

const GiftCard = ({ item, idx }) => {
  const img = item.image_id ? imageUrl(item.image_id) : null;
  return (
    <div
      data-testid={`gaveliste-item-${idx}`}
      className="bg-[#EAEDDC]/40 p-8 md:p-10 text-center flex flex-col"
    >
      {img && (
        <div className="img-zoom aspect-[4/3] mb-8">
          <img src={img} alt={item.title || ""} className="w-full h-full object-cover" loading="lazy" />
        </div>
      )}
      {item.title && (
        <h3 className="font-serif text-2xl md:text-3xl text-[#3D5E68] mb-4">
          {item.title}
        </h3>
      )}
      {item.desc && (
        <p className="text-[#5A7682] font-light leading-relaxed mb-6 flex-1">
          {item.desc}
        </p>
      )}
      {item.link_url && (
        <a
          href={item.link_url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`gaveliste-item-${idx}-link`}
          className="inline-block self-center mt-2 px-8 py-3 border border-[#3D5E68] text-xs uppercase tracking-[0.25em] text-[#3D5E68] hover:bg-[#3D5E68] hover:text-[#F3F5E7] transition-colors duration-500"
        >
          {item.link_label || "Åpne lenke"}
        </a>
      )}
    </div>
  );
};
